import { SxProps } from "@mui/material";
import colors from "../../theme/Colours";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const fontStyles: SxProps = {
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "12px",
  color: colors.sortFontColor,
};

export const getFontStyle = (isSeller: boolean): SxProps => ({
  fontFamily: "Poppins",
  fontSize: "12px",
  fontWeight: isSeller ? 500 : 400,
  color: isSeller ? colors.searchInputText : colors.black,
});

export const activeFontStyles: SxProps = {
  ...fontStyles,
  fontWeight: 600,
  color: colors.sortActiveFontColor,
};

interface ContainerProps {
  variant?: "seller" | "customer";
}

// Main container
export const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "variant",
})<ContainerProps>(({ variant }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
  background:
    variant === "customer"
      ? colors.background2
      : variant === "seller"
        ? colors.background2
        : colors.sortContainerBG,
  border:
    variant === "customer"
      ? `1px solid ${colors.sortContainerCPborder}`
      : variant === "seller"
        ? `1px solid ${colors.searchInputBorder}`
        : "none",
  borderRadius:
    variant === "customer" ? "4px" : variant === "seller" ? "8px" : "10px",
  padding: "10px 14px",
  minWidth: variant === "seller" ? "70px" : "120px",
  width:
    variant === "seller"
      ? "68.46px"
      : variant === "customer"
        ? "fit-content"
        : "120px",
  boxShadow: !variant
    ? `0px 4px 4px 0px ${colors.sortContainerBoxShadow}`
    : "none",
}));

export const DateRangeContainer = styled(Container, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<ContainerProps & { isMobile: boolean }>(({ isMobile }) => ({
  width: isMobile ? "auto" : "158px",
}));

export const Dropdown = styled(Container)<ContainerProps>(
  ({ theme, variant }) => ({
    flexDirection: "column",
    position: "absolute",
    zIndex: 999,
    marginTop: "45px",
    alignItems: "flex-start",
    width: variant === "seller" ? "70px" : "108px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
    [theme.breakpoints.up("sm")]: {
      width: variant !== "seller" ? "120px" : "70px",
    },
  })
);
